export default __webpack_public_path__ + "static/media/NTEX CLASS-8_SYLLABUS_2025-26.f0ff2da5.pdf";